export default "__VITE_PUBLIC_ASSET__5804959a__"